import cn from 'classnames';
import type { MonthDuration, MonthGridCell, MonthPickerMonth } from '../../types/calendar';
import { Languages, monthNames } from '../../util/calendar';
import { useMonthGrid } from './hooks/useMonthGrid';

import styles from './MonthPicker.module.css';

interface MonthPickerProps {
    travelMonths: MonthPickerMonth[];
    duration: MonthDuration;
    toggleMonth: (month: MonthPickerMonth) => void;
    title?: string;
}

export const MonthPicker = ({ travelMonths, toggleMonth, title }: MonthPickerProps) => {
    const today = new Date();
    const { grid, toggle } = useMonthGrid(today.getFullYear(), today.getMonth(), 12, travelMonths);

    const fullMonthNames = monthNames[Languages.NO as keyof typeof monthNames];

    const handleToggle = (cell: MonthGridCell) => {
        toggleMonth({ month: cell.month, year: cell.year });
        toggle(cell);
    };

    const monthCheckboxKey = (cell: MonthGridCell) => `month-${cell.year}-${cell.month}`;

    return (
        <div className={styles['month-picker']}>
            {title && <strong className={styles['month-picker__title']}>{title}</strong>}
            {Object.entries(grid).map(([year, months]) => (
                <fieldset key={year} className={styles['month-picker__fieldset']}>
                    <legend className={styles['month-picker__legend']}>{year}</legend>
                    {Object.values(months).map((cell) => (
                        <label
                            key={monthCheckboxKey(cell)}
                            htmlFor={monthCheckboxKey(cell)}
                            className={cn(styles['month-cell'], {
                                [styles['month-cell--selected']]: cell.selected,
                            })}>
                            <input
                                id={monthCheckboxKey(cell)}
                                type="checkbox"
                                name="travelMonths"
                                checked={cell.selected}
                                onChange={() => handleToggle(cell)}
                                className="sr-only"
                            />
                            {fullMonthNames[cell.month - 1]}
                        </label>
                    ))}
                </fieldset>
            ))}
        </div>
    );
};
